import React, {useState} from 'react';
import PageForm from "components/pageForm";
import {Outlet} from "react-router-dom";
import SubNavbar from "components/SubNavbar/SubNavbar";
import SearchBar from "components/search/SearchBar";
import {TabF, TabsF} from "components/tabs/tabfile";

const Contract = () => {
    const [searchValue, setSearchValue] = useState('');
    const [searchType, setSearchType] = useState('all');

    const contractSearchTypes = [
        { value: 'all', label: 'Tout', placeholder: 'Rechercher...' },
        { value: 'interimaire', label: 'Intérimaire', placeholder: 'Rechercher un intérimaire...' },
        { value: 'contrat', label: 'N° de contrat', placeholder: 'Rechercher un numéro de contrat...' },
        { value: 'mission', label: 'Mission', placeholder: 'Rechercher une mission (intitulé ou numéro)...' },
        { value: 'date', label: 'Date', placeholder: 'Rechercher par date...' }
    ];

    return (
        <>
            <PageForm>
                <SubNavbar>
                    <div className="w-full flex items-stretch h-full">
                        <div className="w-full flex flex-col tab:flex-row tab:justify-between gap-3">
                            <div className="flex items-center h-full">
                                <TabsF>
                                    <TabF label={"toBeSigned"} tabName={'À signer'}/>
                                    <TabF label={"signed"} tabName={'Signé'}/>
                                </TabsF>
                            </div>
                            <div className="flex flex-col tab:flex-row items-stretch tab:items-center gap-3 flex-shrink-0 tab:ml-4">
                                <SearchBar
                                    searchValue={searchValue}
                                    onSearchChange={setSearchValue}
                                    searchType={searchType}
                                    onSearchTypeChange={setSearchType}
                                    placeholder="Rechercher..."
                                    customSearchTypes={contractSearchTypes}
                                />
                            </div>
                        </div>
                    </div>
                </SubNavbar>
                <div className="col-span-12">
                    <Outlet context={{ searchValue, searchType }} />
                </div>
            </PageForm>
        </>
    );
};

export default Contract;

